import React from "react";
import dateFormat from "dateformat";


class InventoryProduct extends React.Component {

    render() {
        const {getNombreAlmacen} = this.context;

        return (
            <>
                {this.props.inventory !== undefined && this.props.inventory.length > 0 ?
                    <div className="mt-3 histoty">
                        <div className="history-table">
                            <h4>Histórico de inventario</h4>
                            <table className="table">
                                <thead>
                                <tr>
                                    <th scope="col">Almacen</th>
                                    <th scope="col">Stock</th>
                                    <th scope="col">Fecha</th>
                                </tr>
                                </thead>
                                <tbody>
                                {this.props.inventory.map(function (d, index) {
                                    return (<tr key={index}>
                                        <td>{getNombreAlmacen(d.almacen)}</td>
                                        <td>{d.stock}</td>
                                        <td>{dateFormat(d.fecha, "dd/mm/yy")}</td>
                                    </tr>)
                                })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                : ''}
            </>

        );
    }
}

export default InventoryProduct;